import { Box, useTheme } from '@mui/material';

import {
  CohortBuilderEditModalActionButton,
  type CohortBuilderEditModalActionButtonProps,
} from './CohortBuilderEditModalActionButton';

export interface CohortBuilderEditModalActionsProps {
  id: string;
  actions: CohortBuilderEditModalActionButtonProps[];
}

export const CohortBuilderEditModalActions = ({
  id,
  actions,
}: CohortBuilderEditModalActionsProps) => {
  const theme = useTheme();

  return (
    <Box
      data-testid={`cohort-builder-edit-modal-actions-${id}`}
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        px: theme.spacing(6),
        gap: theme.spacing(4),
        flexWrap: 'wrap',
        padding: 0,
      }}
    >
      {actions.map((action) => (
        <CohortBuilderEditModalActionButton key={action.id} {...action} />
      ))}
    </Box>
  );
};
